<template>
    <b-card class="shadow" style="min-height: 700px" id="printme">
        <div class="row">
            <div class="col-12">
                <div
                    class="d-flex align-items-center justify-content-between mb-4"
                >
                    <h5 class="mb-0 text-gray-800">
                        {{ $t("Todos os Ofícios") }}
                    </h5>
                    <b-button-group>
                        <b-button
                            variant="outline-dark"
                            :class="viewFilterReport === true ? 'active' : ''"
                            @click="viewFilters"
                        >
                            <i class="fas fa-filter"></i>
                            {{ $t("Filtros") }}
                        </b-button>
                        <b-button variant="outline-dark" @click="print()">
                            <i class="fas fa-print"></i>
                        </b-button>
                        <b-button
                            variant="outline-dark"
                            @click="exportar()"
                            :title="$t('Exportar')"
                            v-b-tooltip.hover
                        >
                            <i class="fas fa-file-excel"></i>
                        </b-button>
                    </b-button-group>
                </div>
            </div>

            <div class="col-12" v-if="viewFilterReport">
                <!-- Filtros -->
                <form @submit.prevent="getAnalytics" ref="addItem">
                    <div class="row">
                        <form-calendar
                            v-model="data_inicio"
                            grid="6"
                            label="Data inicial"
                        />

                        <form-calendar
                            v-model="data_fim"
                            grid="6"
                            label="Data final"
                            :required="verificaDataInicial"
                            :min-date="data_inicio"
                        />

                        <div class="col-md-8">
                            <label for="input-search">
                                <b
                                    >Pesquisar por Assunto, número ou
                                    destinatário</b
                                >
                            </label>
                            <b-input
                                placeholder="Digite o nome de um destinatário, assunto ou número e clique em Gerar Relatório "
                                class="form-control search-input"
                                type="text"
                                v-model="search"
                            />
                        </div>

                        <form-select
                            v-model="filtroStatus"
                            grid="4"
                            label="Status"
                            :itens="status"
                            :loading="loadingStatus"
                            :disabled="loadingStatus"
                            :multiple="true"
                        />

                        <form-select
                            v-model="filtroUnidades"
                            label="Filtrar por Unidade(s)"
                            :itens="unidades"
                            :disabled="loadingSearchUnidade"
                            :loading="loadingSearchUnidade"
                            :grid="6"
                            @input="getTecnicos()"
                            multiple
                        />

                        <form-select
                            v-model="filtroTecnicos"
                            label="Filtrar por Técnico(s)"
                            :itens="listtecnicos"
                            :disabled="loadingSearchTecnico"
                            :grid="6"
                            placeholder="Selecione uma unidade antes"
                            multiple
                        />
                    </div>
                    <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
                        <div class="col-auto px-2 text-right">
                            <button
                                class="btn btn-default"
                                @click.prevent="
                                    limparFiltros(), (viewFilterReport = false)
                                "
                            >
                                <i class="fas fa-times"></i>
                            </button>

                            <button
                                type="button"
                                class="btn btn-secondary"
                                @click.prevent="limparFiltros()"
                            >
                                {{ $t("Limpar Filtros") }}
                            </button>

                            <button
                                class="btn btn-success btn-submit"
                                data-style="zoom-in"
                                type="submit"
                            >
                                <i class="fas fa-chart-bar"></i>
                                {{ $t("Gerar Relatório") }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <loading-report
                :loading="isLoadingMsg"
                mensagem="Por favor aguarde estamos realizando sua solicitação..."
                icone="fa-smile-wink"
            ></loading-report>

            <div class="col-md-12">
                <loading-animation
                    :active.sync="loading"
                    :is-full-page="false"
                    :opacity="1"
                    color="#5895FF"
                />

                <print-content>
                    <template v-slot:datas>
                        <p
                            class="d-flex align-items-center justify-content-between mb-4"
                        >
                            <span
                                >Período selecionado:
                                <b>{{ datas.start }} - {{ datas.end }}</b>
                                <b-link
                                    href="#"
                                    @click.prevent="void 0"
                                    class="mb-2"
                                    variant="info"
                                    v-b-popover.hover.top="
                                        'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                                    "
                                >
                                    <i class="fas fa-info-circle"></i> </b-link
                            ></span>

                            <span v-if="pagination.total"
                                >Total de Registros <b>{{ pagination.total }}</b
                                >, total por página
                                <b>{{ pagination.perPage }}</b></span
                            >
                        </p>
                    </template>

                    <b-table
                        :fields="[
                            {
                                key: 'numero',
                                label: $t('Detalhes'),
                            },
                            {
                                key: 'cadastrado',
                                label: $t('Data'),
                            },
                            {
                                key: 'status_nome',
                                label: $t('Status'),
                            },
                            {
                                key: 'actions',
                                label: '',
                                class: 'text-right no-print',
                                thStyle: { width: '95px', minWidth: '95px' },
                            },
                        ]"
                        :items="itensList"
                        :responsive="true"
                        striped
                        hover
                        show-empty
                        small
                        outlined
                        stacked="xs"
                        table-class="mb-3"
                    >
                        <template v-slot:cell(numero)="data">
                            Número:
                            <strong>
                                {{ data.item.numero }}
                            </strong>
                            <br />
                            Destinatário:
                            <strong>
                                {{ data.item.nome_completo_detinatario }}
                            </strong>
                            <br />
                            Assunto:
                            <strong>
                                {{ data.item.assunto }}
                            </strong>
                            <br />
                            Técnico:
                            <strong>
                                {{ data.item.tecnico }}
                            </strong>
                            <br />
                            Unidade:
                            <strong>
                                {{ data.item.unidade.nome }}
                            </strong>
                            <br />
                            <i
                            class="mdi mdi-lock mdi-18px text-danger"
                            v-if="data.item.privado == 1"
                            v-b-popover.hover.top="'Oficio com Sigilo'"
                            ></i>
                        </template>
                        <template v-slot:cell(cadastrado)="data">
                            {{ data.item.cadastrado }}
                        </template>
                        <template v-slot:cell(status_nome)="data">
                            <span
                                class="small"
                                v-html="data.item.status_nome"
                            ></span>
                        </template>
                        <template v-slot:cell()="data">
                            <button
                                @click="redirectOficio(data.item.id)"
                                class="px-2 mb-0 btn btn-sm btn-success"
                            >
                                <i class="mdi mdi-square-edit-outline" />
                            </button>
                        </template>
                        <template v-slot:empty="scope">
                            <div class="text-center my-5">
                                <img
                                    :alt="$t('No results')"
                                    class="mb-5"
                                    src="/img/icons/robot.svg"
                                    style="max-height: 165px"
                                />
                                <h3 class="bold">
                                    {{ $t("No records found") }}
                                </h3>
                            </div>
                        </template>
                    </b-table>
                </print-content>

                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="form-group d-inline-flex mb-0">
                            <select
                                class="form-control"
                                style="width: 70px"
                                v-model="perPage"
                                v-on:change="getAnalytics"
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                        <div class="d-inline-flex ml-2">
                            <b-pagination
                                :per-page="perPage"
                                :total-rows="pagination.total"
                                @change="changePage"
                                v-model="page"
                            />
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                        <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }} {{ $t("of") }}
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                        </div>
                    </div>
                </div>
                <div class="box-btn-print no-print">
                    <b-button
                        v-if="!loading"
                        :title="$t('Visualizar e Imprimir')"
                        class="py-2"
                        size="sm"
                        type="button"
                        v-b-tooltip.hover
                        variant="primary"
                        @click="print()"
                    >
                        <i class="fas fa-print"></i>
                    </b-button>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
export default {
    name: "HomeReportOficios",
    data() {
        return {
            loading: true,
            range: null,
            itensList: [],
            page: 1,
            search: "",
            perPage: 10,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            filtros: {
                unidade: null,
            },
            isLoadingMsg: false,
            loadingSearchUnidade: true,
            loadingSearchTecnico: true,
            unidades: [],
            unidades: [],
            tecnicos: [],
            filter: false,
            user_id: null,
            tecnico_id: null,
            unidade_id: null,
            role: null,
            loadingStatus: false,
            datas: [],
            filtroUnidades: [],
            filtroDatas: [],
            filtroStatus: [],
            filtroTecnicos: [],
        };
    },
    mounted() {
        this.getStatus();
        this.getUnidades();
        this.getAnalytics();
    },
    computed: {
        listtecnicos() {
            const pessoas = this.tecnicos;

            const map = pessoas.map((elem) => ({
                id: elem.id,
                value: " <b>" + elem.value + "</b> - "  + (elem.profissao ?? 'Não informado') + " - " + elem.nome_unidade,
            }));
            return map;
        },
    },
    methods: {
        redirectOficio(id) {
            const url = this.$router.resolve(`/dashboard/oficios/edit/${id}`).href;

            window.open(url, '_blank');
        },
        filterData(value) {
            return this.$options.filters.formatDateHora(value);
        },
        updateAnalytics(range) {
            if (this.range !== range) {
                this.range = range;
                this.getAnalytics();
            }
        },
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getAnalytics();
            }
        },
        getAnalytics() {
            this.isLoadingMsg = true;
            this.loading = true;

            this.filtroDatas = [];
            if (this.data_inicio) {
                this.filtroDatas.push(
                    this.$options.filters.formatDateYMD(this.data_inicio)
                );
            }
            if (this.data_fim) {
                this.filtroDatas.push(
                    this.$options.filters.formatDateYMD(this.data_fim)
                );
            }

            axios
                .get("api/dashboard/report/oficios/home", {
                    params: {
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                        range: this.range,
                        filtroUnidades: this.filtroUnidades,
                        filtroStatus: this.filtroStatus,
                        filtroDatas: this.filtroDatas,
                        filtroTecnicos: this.filtroTecnicos,
                    },
                })
                .then((response) => {
                    this.loading = false;

                    this.user_id = this.$store.state.user.id;
                    this.tecnico_id = this.$store.state.user.tecnico.id;
                    this.unidade_id = this.$store.state.unidade;
                    this.role = this.$store.state.user.role;

                    this.datas = response.data.datas;
                    this.itensList = response.data.dados.original.data;
                    this.pagination = response.data.dados.original.pagination;
                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getAnalytics();
                    } else {
                        this.isLoadingMsg = false;
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.isLoadingMsg = false;
                    this.loading = false;
                });
        },
        getUnidades() {
            this.loadingSearchUnidade = true;
            axios
                .get(`api/dashboard/unidades/get/externas`)
                .then((response) => {
                    this.unidades = response.data;
                })
                .finally(() => (this.loadingSearchUnidade = false));
        },
        getTecnicos() {
            this.tecnicos = [];
            this.loadingSearchTecnico = true;
            axios
                .get(`api/dashboard/report/oficios/tecnicos/get`, {
                    params: {
                        unidades: this.filtroUnidades,
                    },
                })
                .then((response) => {
                    this.tecnicos = response.data;
                })
                .finally(() => (this.loadingSearchTecnico = false));
        },
        getStatus() {
            this.loadingStatus = true;
            axios
                .get(`api/dashboard/report/status/oficios`)
                .then((response) => {
                    this.status = response.data;
                })
                .finally(() => {
                    this.loadingStatus = false;
                });
        },
        exportar() {
            this.isLoadingMsg = true;
            this.loading = true;
            swal.fire({
                title: "Aguarde! O Arquivo está sendo gerado.",
                text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
                imageUrl: `${window.urlbase}img/load.gif`,
                showConfirmButton: false,
            });
            axios
                .get("api/dashboard/report/oficios/home", {
                    params: {
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                        range: this.range,
                        filtroUnidades: this.filtroUnidades,
                        filtroStatus: this.filtroStatus,
                        filtroDatas: this.filtroDatas,
                        filtroTecnicos: this.filtroTecnicos,
                        export: "ok",
                    },
                })
                .then((response) => {
                    this.isLoadingMsg = false;
                    this.loading = false;

                    swal.fire({
                        title: "Arquivo Pronto para Download!",
                        html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
                        icon: "success",
                        showConfirmButton: false,
                    });
                })
                .finally(() => {
                    (this.isLoadingMsg = false), (this.loading = false);
                });
        },
        limparFiltros() {
            //   this.filtros = {};
            this.data_inicio = "";
            this.data_fim = "";
            this.filtroUnidades = [];
            this.filtroStatus = [];
            this.range = null;

            this.getAnalytics();
        },
    },
};
</script>
